:host {
  display: block;
  width: 100%;
}

 .kt-subheader__main {
  display: flex
  ;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      padding: 0.25rem 0;
  }


  .kt-subheader__breadcrumbs {
    display: flex
;
    align-items: center;
    list-style-type: none;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
}
.kt-subheader__breadcrumbs-link {
    padding: 0 0.5rem 0 0;
    font-size: 1rem;
    font-weight: 500;
  color: #005b88 ;
    transition: all 0.3s;
    text-decoration:none;
}

.kt-subheader__breadcrumbs-link {
 color: #005b88
}

 .kt-svg-icon.fav-icon {
    width: 17px;
    height: 17px;
    transform: scaleX(-1);
}

.kt-svg-icon.inactive {
    opacity: 0.35;
}
.kt-svg-icon g [fill] {
    fill: #008fc7;
}

.kt-subheader__breadcrumbs-separator:after {
    display: block;
    width: 1px;
    height: 16px;
    border-radius: 0;
    content: " ";
    background: #e7e8ef;
}
 .kt-subheader__breadcrumbs-separator:after {
    background: #dbdce7;
}

.kt-subheader__breadcrumbs-separator {
    display: flex
;
    justify-content: content;
    align-items: center;
    padding: 0 0.5rem 0 0;
}
 .kt-subheader__toolbar {
    display: flex
;
    justify-content: flex-end;
    align-items: center;
    padding: 0;
}

 .btn {
    display: inline-flex
;
    height: 32px !important;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.btn.btn-icon {
    width: 32px !important;
    align-items: center;
}
.btn:not(.dropdown-toggle-split) {
    margin-left: 0.5rem;
}
.btn:not(.dropdown-toggle-split) {
    margin-left: 0.25rem;
}
.kt-svg-icon.inactive {
    opacity: 0.35;
}

.kt-svg-icon {
    height: 23px;
    width: 23px;
}


.fav-cont {
  display: flex
;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
}

.kt-subheader__breadcrumbs-item:after {
  display: block;
  width: 1px;
  height: 16px;
  border-radius: 0;
  content: " ";
  background: #dbdce7;
  top:3px;
  right: 0;
}.kt-subheader__breadcrumbs-link {
  position: relative;
  display: inline-flex;
  justify-content: space-between;
}

.kt-subheader__breadcrumbs-item:after {
  top: 3px;
  position: absolute;
  right: 12px;
}.kt-subheader__breadcrumbs-link i {
  font-size: 14px;
}



span.kt-subheader__breadcrumbs-link.kt-subheader__breadcrumbs-item {
  padding-right: 20px;
}

input[type="text"] {
 
  border: 1px solid #e2e5ec;
  border-radius: 4px;
}



.kt-subheader__breadcrumbs-link:hover {
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  color: #1582b8;
}
.kt-subheader__breadcrumbs-item:last-child:after {
  display: none;
}
.no-items{
  font-weight: bold
}

.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 5px;
  color: white;
  font-size: 14px;
  z-index: 9999;
  animation: fadeInOut 3s ease-in-out;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.toast.success {
  background-color: #2ecc71;
}

.toast.error {
  background-color: #e74c3c;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateY(-20%);
  }
  10% {
    opacity: 1;
    transform: translateY(0%);
  }
  90% {
    opacity: 1;
    transform: translateY(0%);
  }
  100% {
    opacity: 0;
    transform: translateY(-20%);
  }
}


.toggle-favorites-btn {
  text-align: center;
  margin-top: 10px;
}

.toggle-favorites-btn button {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-weight: bold;
}

.toggle-favorites-btn{
  display: block;
  margin: auto;
}

/* Overlay */
.confirmation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Modal box */
.confirmation-modal {
  background: #fff;
  padding: 20px 25px;
  border-radius: 8px;
  max-width: 320px;
  width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  text-align: center;
  font-family: Arial, sans-serif;
}

/* Modal text */
.confirmation-modal p {
  margin-bottom: 20px;
  font-size: 16px;
  color: #333;
}

/* Buttons container */
.modal-buttons {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

/* Buttons */
.modal-buttons .btn {
  flex: 1;
  padding: 8px 12px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
  transition: background 0.2s;
}

.modal-buttons .btn-no {
  background: #e0e0e0;
  color: #555;
    justify-content: center;
}

.modal-buttons .btn-no:hover {
  background: #ccc;
}

.modal-buttons .btn-yes {
  background: #005b88;
  color: white;

    justify-content: center;
}

.modal-buttons .btn-yes:hover {
  background:#005b88;
}
.kt-subheader__breadcrumbs-link {
  color: #005b88 !important;
}.no-items {
  color:  #005b88 !important;
}

.add-favorite-modal {
  min-width: 320px;
  max-width: 400px;
}

.add-modal-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #005b88;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1.5px solid #e0eef4;
}

.add-modal-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}

.add-modal-label {
  font-size: 15px;
  font-weight: 500;
  color: #555;
     display: flex;
      align-items: flex-start;
 
}

.add-modal-input {
  width: 100%;
  padding: 8px 12px;
  border: 1.5px solid #c8dfe8;
  border-radius: 7px;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.add-modal-input:focus {
  border-color: #005b88;
}

.add-modal-hint {
  font-size: 11px;
  color: #aaa;
}